<template>
  <div>
    <header-info cur="0"></header-info>
    <div
      id="center"
      class="hidebox"
    >
      <div
        id="content"
        class="content"
      >
        <div class="banner-wrap">
          <swiper
            class="swiper"
            :options="swiperOption"
          >
            <swiper-slide
              v-for="item in flashData"
              :key="item.id"
            >
              <img
                :src="item.imgPath"
                :onerror="$store.state.defaultImg"
              >
            </swiper-slide>
            <div
              class="swiper-pagination"
              slot="pagination"
            ></div>
          </swiper>
          <div class="banner-bottom" v-show="noticeData.length > 0 || newData.length > 0">
            <div class="left-box">
              <div class="box-wrap inform-wrap">
                <div class="title-wrap">
                  <p class="title">通知公告</p>
                  <router-link
                    class="more"
                    to="/www/more?category=1"
                  ><i class="icon iconfont">&#xec1c;</i></router-link>
                </div>
                <ul class="box-list">
                  <li
                    v-for="item in noticeData"
                    :key="item.id"
                  >
                    <router-link :to="'/www/news/detail?id=' + item.id + '&category='+item.category">
                      <p class="time">{{item.publishDate}}</p>
                      <p
                        class="text"
                        :title="item.title"
                      >{{formatInfoTitle(item.title)}}</p>
                    </router-link>
                  </li>
                </ul>
              </div>
              <div class="box-wrap news-wrap">
                <div class="title-wrap">
                  <p class="title">新闻资讯</p>
                  <router-link
                    class="more"
                    to="/www/more?category=2"
                  ><i class="icon iconfont">&#xec1c;</i></router-link>
                </div>
                <ul class="box-list">
                  <li
                    v-for="item in newData"
                    :key="item.id"
                  >
                    <router-link :to="'/www/news/detail?id=' + item.id + '&category='+item.category">
                      <p class="time">{{item.publishDate}}</p>
                      <p
                        class="text"
                        :title="item.title"
                      >{{formatInfoTitle(item.title)}}</p>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-wrap mw" style="display: none">
          <ul class="tab-list">
            <li class="on" v-show="countryData.length > 0"><a href="#a1">国家认定项目</a></li>
            <li v-show="provincialData.length > 0"><a href="#a2">省级认定项目</a></li>
            <li v-show="schoolData.length > 0"><a href="#a3">校级认定项目</a></li>
          </ul>
        </div>
        <!-- 国家认定项目 -->
        <div
          class="item-wrap mw"
          id="a1"
          v-show="countryData.length > 0"
        >
          <div class="title-wrap">
            <p class="title title-line-red">国家认定项目</p>
            <router-link
              class="more"
              :to="{ path: '/www/search', query: { t: this.utils.encryptDes('1')}}"
            ><i class="icon iconfont">&#xec1c;</i></router-link>
          </div>
          <ul class="item-list">
            <li
              v-for="item in countryData"
              :key="item.id"
            >
              <router-link :to="'/www/experiment?id=' + item.id">
                <div class="img-wrap">
                  <img
                    :src="item.logo"
                    :onerror="$store.state.defaultImg"
                  />
                  <span class="mark bg-red">国</span>
                </div>
                <div class="biaoti-wrap">
                  <span class="score">{{item.appraise_avg?parseFloat(item.appraise_avg).toFixed(1):'0.0'}}</span>
                  <p class="biaoti">{{item.title}}</p>
                </div>
                <div class="msg-wrap">
                  <p class="p1">
                    <span>{{item.school_title?item.school_title:'--'}}</span><span class="line">|</span><span>{{item.master_name?item.master_name:'--'}}</span>
                  </p>
                  <p class="p2">
                    <span><i class="iconfont">&#xe670;</i>{{item.student_count?item.student_count:'0'}}</span>
                    <span><i class="iconfont">&#xe62f;</i>{{item.view_count?item.view_count:'0'}}</span>
                  </p>
                </div>
              </router-link>
            </li>
            <div
              class="no-info"
              v-if="!countryData.length"
            >暂无数据</div>
          </ul>
        </div>
        <!-- 省级认定项目 -->
        <div
          class="item-wrap mw"
          id="a2"
          v-show="provincialData.length > 0"
        >
          <div class="title-wrap">
            <p class="title title-line-blue">省级认定项目</p>
            <router-link
              class="more"
              :to="{ path: '/www/search', query: { t: this.utils.encryptDes('2')}}"
            ><i class="icon iconfont">&#xec1c;</i></router-link>
          </div>
          <ul class="item-list">
            <li
              v-for="item in provincialData"
              :key="item.id"
            >
              <router-link :to="'/www/experiment?id=' + item.id">
                <div class="img-wrap">
                  <img
                    :src="item.logo"
                    :onerror="$store.state.defaultImg"
                  />
                  <span class="mark bg-blue">省</span>
                </div>
                <div class="biaoti-wrap">
                  <span class="score">{{item.appraise_avg?parseFloat(item.appraise_avg).toFixed(1):'0.0'}}</span>
                  <p class="biaoti">{{item.title}}</p>
                </div>
                <div class="msg-wrap">
                  <p class="p1">
                    <span>{{item.school_title?item.school_title:'--'}}</span><span class="line">|</span><span>{{item.master_name?item.master_name:'--'}}</span>
                  </p>
                  <p class="p2">
                    <span><i class="iconfont">&#xe670;</i>{{item.student_count?item.student_count:'0'}}</span>
                    <span><i class="iconfont">&#xe62f;</i>{{item.view_count?item.view_count:'0'}}</span>
                  </p>
                </div>
              </router-link>
            </li>
            <div
              class="no-info"
              v-if="!provincialData.length"
            >暂无数据</div>
          </ul>
        </div>
        <!-- 校级认定项目 -->
        <div
          class="item-wrap mw"
          id="a3"
          v-show="schoolData.length > 0"
        >
          <div class="title-wrap">
            <p class="title title-line-green">校级认定项目</p>
            <router-link
              class="more"
              :to="{ path: '/www/search', query: { t: this.utils.encryptDes('3')}}"
            ><i class="icon iconfont">&#xec1c;</i></router-link>
          </div>
          <ul class="item-list">
            <li
              v-for="item in schoolData"
              :key="item.id"
            >
              <router-link :to="'/www/experiment?id=' + item.id">
                <div class="img-wrap">
                  <img
                    :src="item.logo"
                    :onerror="$store.state.defaultImg"
                  />
                  <span class="mark bg-green">校</span>
                </div>
                <div class="biaoti-wrap">
                  <span class="score">{{item.appraise_avg?parseFloat(item.appraise_avg).toFixed(1):'0.0'}}</span>
                  <p class="biaoti">{{item.title}}</p>
                </div>
                <div class="msg-wrap">
                  <p class="p1">
                    <span>{{item.school_title?item.school_title:'--'}}</span><span class="line">|</span><span>{{item.master_name?item.master_name:'--'}}</span>
                  </p>
                  <p class="p2">
                    <span><i class="iconfont">&#xe670;</i>{{item.student_count?item.student_count:'0'}}</span>
                    <span><i class="iconfont">&#xe62f;</i>{{item.view_count?item.view_count:'0'}}</span>
                  </p>
                </div>
              </router-link>
            </li>
            <div
              class="no-info"
              v-if="!schoolData.length"
            >暂无数据</div>
          </ul>
        </div>
        <!-- 实验学习 -->
        <div class="experiment-wrap" v-show="lessonData.length > 0">
          <div class="mw">
            <div class="title-wrap">
              <p class="title">
                <span>课程学习</span>
              </p>
            </div>
            <div class="experiment-list">
              <router-link
                class="more"
                to="/www/study"
              ><i class="icon iconfont">&#xec1c;</i></router-link>
              <ul>
                <li
                  v-for="item in lessonData"
                  :key="item.id"
                >
                  <router-link :to="'/www/lesson_detail?id=' + item.id">
                    <div class="img-wrap">
                      <img
                        :src="item.logoPath?item.logoPath:'--'"
                        :onerror="$store.state.defaultImg"
                      />
                    </div>
                    <div class="biaoti-wrap">
                      <p class="p1">{{item.title}}</p>
                      <p class="p2"><span>第一学期</span><span class="line">|</span><span>进行第{{getWeek(item.startTime)}}周，共{{item.allTime}}周</span></p>
                    </div>
                    <div class="msg-wrap">
                      <p class="p1">
                        <span>{{item.school_title?item.school_title:'--'}}</span><span class="line">|</span><span>{{item.manager_name?item.manager_name:'--'}}</span>
                      </p>
                      <p class="p2"><i class="iconfont">&#xe670;</i>{{item.student_count?item.student_count:'0'}}人学习</p>
                    </div>
                  </router-link>
                </li>
                <div
                  class="no-info"
                  v-if="!lessonData.length"
                >暂无数据</div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="south"
      ref="south"
    >
      <footer-info></footer-info>
      <Questionnaire></Questionnaire>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import Questionnaire from '../../../components/Questionnaire'
export default {
  name: 'Index',
  metaInfo: {
    meta: [
      { name: 'keywords', content: '虚拟仿真,实验,实验项目,本科,专科' }
    ]
  },
  components: {
    HeaderInfo,
    FooterInfo,
    Questionnaire
  },
  data() {
    return {
      // flashData: this.$store.state.flashList,
      noticeData: [],
      newData: [],
      countryData: [],
      provincialData: [],
      schoolData: [],
      lessonData: [],
      countryDataMobile: [],
      provincialDataMobile: [],
      schoolDataMobile: [],
      lessonDataMobile: []

    }
  },
  computed: {
    flashData () {
      return this.$store.state.flashList
    },
    swiperOption() {
      if (this.$store.state.flashList && this.$store.state.flashList.length >= 2) {
        return {
          slidesPerView: 1,
          // autoplay: false,
          autoplay: {
            delay: 5000
          },
          autoHeight: true,
          loop: true,
          // 显示分页
          pagination: {
            el: '.swiper-pagination'
          }
        }
      } else {
        return {
          slidesPerView: 1,
          autoplay: false,
          // autoplay: {
          //   delay: 100
          // },
          autoHeight: true,
          loop: true,
          // 显示分页
          pagination: {
            el: '.swiper-pagination'
          }
        }
      }
    }
  },
  methods: {
    // 计算当前时间处于第几周
    getWeek (dt) {
      var _this = this
      const yy = new Date().getFullYear()
      const mm = new Date().getMonth() + 1
      const dd = new Date().getDate()
      _this.gettime = yy + '-' + mm + '-' + dd
      const d1 = new Date(dt) // 开始时间
      const d2 = new Date(_this.gettime) // 当前时间日期
      const rq = Number(d2) - Number(d1)
      const days = Math.ceil(rq / (24 * 60 * 60 * 1000))
      const num = Math.ceil(Number(days) / 7)
      return num
    },
    formatInfoTitle (title) {
      if (title.length <= 15) {
        return title
      } else {
        return title.substr(0, 15) + '...'
      }
    },
    toProvincePortal () {
      window.open('http://portal.jxedu.gov.cn/', '_blank')
    },
    getIndexData() {
      this.$http.get('/index_data/?category=flash_data').then((data) => {
        this.$store.commit('setFlashList', data.flash_data)
      })
      this.$http.get('/index_data/?category=info_data1').then((data) => {
        this.noticeData = data.info_data1
      })
      this.$http.get('/index_data/?category=info_data2').then((data) => {
        this.newData = data.info_data2
      })
      this.$http.get('/index_data/?category=exp_data1').then((data) => {
        this.countryData = data.exp_data1
        this.countryDataMobile = data.exp_data1
      })
      this.$http.get('/index_data/?category=exp_data2').then((data) => {
        this.provincialData = data.exp_data2
        this.provincialDataMobile = data.exp_data2
      })
      this.$http.get('/index_data/?category=exp_data3').then((data) => {
        this.schoolData = data.exp_data3
        this.schoolDataMobile = data.exp_data3
      })
      this.$http.get('/index_data/?category=lesson_data').then((data) => {
        this.lessonData = data.lesson_data
        this.lessonDataMobile = data.lesson_data
      })
    },
    goPath(id, code) {
      if (!this.$store.state.userInfo.profile_id) {
        this.$router.push('/login')
        return
      }
      if (code === 1) {
        this.$router.push('/www/experiment?id=' + id)
      } else {
        this.$router.push('/www/lesson_detail?id=' + id)
      }
    }
  },
  mounted() {
  },
  async created() {
    await this.getIndexData()
  }
}
</script>
<style scoped src="../../../assets/css/dialog.css"></style>
<style scoped src="../../../assets/css/common.css"></style>
<style scoped src="../../../assets/css/index-header.css"></style>
<style scoped src="../../../assets/css/index.css"></style>
<style lang="less" scoped>
#app #center {
  padding-top: 183px;
}
#content {
   padding-bottom: 40px;
}
.banner-wrap {
  position: relative;
  height: 470px;
}
/deep/.banner-wrap .swiper-pagination-bullet-active {
  background: #0047d4;
}
/deep/.banner-wrap .swiper-pagination-bullet {
  width: 30px;
  height: 4px;
  border-radius: 2px;
}
.banner-bottom {
  padding: 30px;
  width: 1200px;
  box-sizing: border-box;
  position: absolute;
  bottom: -120px;
  left: 0;
  right: 0;
  margin: auto;
  z-index: 9;
  background-image: linear-gradient(#12BDAA, transparent);
}
.left-box {
  float: left;
  background-color: #fff;
  padding: 20px 40px;
  width: 1140px;
  box-sizing: border-box;
  height: 202px;
  box-shadow: 0 0 10px #95a1b7;
}
.left-box .title-wrap {
  overflow: hidden;
}
.left-box .title-wrap .title {
  font-size: 20px;
  color: #333;
  font-weight: bold;
  float: left;
  position: relative;
  padding-left: 20px;
}
.left-box .title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 5px;
  height: 20px;
  width: 5px;
  border-radius: 3px;
  background-image: linear-gradient(#86bef1, transparent);
}
.left-box .title-wrap .more {
  float: right;
  width: 48px;
  height: 18px;
  line-height: 18px;
  background: #f1f1f1;
  border-radius: 9px;
  text-align: center;
  color: #565656;
  font-size: 16px;
  font-weight: bold;
}
.left-box .box-wrap {
  float: left;
  width: 520px;
  box-sizing: border-box;
  height: 100%;
}
.left-box .inform-wrap {
  padding-right: 40px;
  border-right: 1px solid #d5d5d5;
}

.left-box .news-wrap {
  padding-left: 40px;
}
.left-box .box-list {
  margin-top: 20px;
}
.left-box .box-list li a {
  line-height: 23px;
  color: #333;
  font-size: 14px;
}
.left-box .text-wrap {
  overflow: hidden;
  line-height: 30px;
}
.left-box .time {
  float: right;
}
.left-box .text {
  padding-right: 120px;
  white-space: nowrap;
}
.right-box {
  width: 290px;
  padding: 5px;
  background-color: #fff;
  box-sizing: border-box;
  float: right;
  height: 202px;
  box-shadow: 0 0 10px #95a1b7;
}
.right-box .item {
  width: 100%;
  height: 62px;
  margin-bottom: 3px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-left: 110px;
  box-sizing: border-box;
  cursor: pointer;
}
.right-box .item:last-child {
  margin-bottom: 0;
}
.right-box .item .text {
  font-size: 20px;
  padding-top: 10px;
  font-weight: bold;
}
.right-box .item .text-en {
  font-size: 12px;
}
.right-box .item1 {
  color: #2d4b8a;
  background-image: url(../../../assets/images/item1.jpg);
}
.right-box .item1 .text-en {
  color: #a1b8e9;
}
.right-box .item2 {
  color: #12869b;
  background-image: url(../../../assets/images/item2.jpg);
}
.right-box .item2 .text-en {
  color: #95cec7;
}
.right-box .item3 {
  color: #cd6f4f;
  background-image: url(../../../assets/images/item3.jpg);
}
.right-box .item3 .text-en {
  color: #e1b58f;
}
.mw {
  width: 1200px;
  margin: 0 auto;
}
.tab-wrap {
  margin-top: 140px;
  text-align: center;
  height: 56px;
}
.tab-list li {
  display: inline-block;
  line-height: 40px;
  padding: 0 50px;
}
.tab-list li a {
  display: block;
  width: 100%;
  font-size: 24px;
  color: #333;
  text-decoration: none;
  padding-bottom: 10px;
}
.tab-list li.on a {
  font-size: 28px;
  color: #222;
  font-weight: bold;
  border-bottom: 5px solid #12BDAA;
}
.tab-list li:hover a {
  border-bottom: 5px solid #12BDAA;
}
.item-wrap {
  margin-top: 40px;
  padding: 20px 30px 0;
  background: #fff;
  overflow: hidden;
  line-height: 30px;
  box-sizing: border-box;
  box-shadow: 0 0 20px #e8f0f6;
}
.item-wrap .title-wrap {
  overflow: hidden;
}
.item-wrap .title-wrap .title {
  font-size: 20px;
  color: #222;
  float: left;
  position: relative;
  padding-left: 20px;
}
.item-wrap .title:before {
  content: "";
  position: absolute;
  left: 0;
  top: 5px;
  height: 20px;
  width: 5px;
  border-radius: 3px;
}
.item-wrap .title-line-red:before {
  background-image: linear-gradient(#fe320c, transparent);
}
.item-wrap .title-line-blue:before {
  background-image: linear-gradient(#155dfe, transparent);
}
.item-wrap .title-line-green:before {
  background-image: linear-gradient(#1bb981, transparent);
}
.item-wrap .title-line-gray:before {
  background-image: linear-gradient(#adadad, transparent);
}
.item-wrap .title-wrap .more {
  float: right;
  width: 48px;
  height: 18px;
  line-height: 18px;
  background: #f1f1f1;
  border-radius: 9px;
  text-align: center;
  color: #555555;
  font-size: 16px;
  font-weight: bold;
}
.item-list {
  margin-top: 20px;
  overflow: hidden;
}
.item-list li {
  float: left;
  width: 346px;
  margin-right: 50px;
  margin-bottom: 30px;
}
.item-list li:nth-child(3n) {
  margin-right: 0;
}
.item-list .img-wrap {
  width: 100%;
  height: 184px;
  position: relative;
}
.item-list .img-wrap img {
  width: 100%;
  height: 100%;
}
.item-list .mark {
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 15px;
  color: #fff;
  position: absolute;
  right: 14px;
  top: 0;
}
.item-list .mark.bg-red {
  background-color: #fe2703;
}
.item-list .mark.bg-blue {
  background-color: #0954ff;
}
.item-list .mark.bg-green {
  background-color: #0fb679;
}
.item-list .biaoti-wrap {
  overflow: hidden;
  padding-top: 10px;
}
.item-list .biaoti-wrap .score {
  float: right;
  font-size: 40px;
  color: #f64000;
  line-height: 50px;
}
.item-list .biaoti-wrap .biaoti {
  font-size: 15px;
  color: #333;
  line-height: 25px;
  padding-right: 40px;
  text-decoration: none;
  font-weight: bold;
  height: 50px;
  overflow: hidden;
}
.item-list .msg-wrap {
  color: #888;
  font-size: 13px;
  margin-top: 20px;
  overflow: hidden;
  line-height: 20px;
}
.item-list .msg-wrap .p1 {
  float: left;
}
.item-list .msg-wrap .p1 .line {
  padding: 0 5px;
}
.item-list .msg-wrap .p2 {
  float: right;
}
.item-list .msg-wrap .p2 span {
  margin-left: 10px;
}
.item-list .msg-wrap .p2 i {
  margin-right: 5px;
  font-size: 14px;
  color: #c5c5c5;
}
.experiment-wrap {
  //background: url(../../../assets/images/experiment-bg.jpg) no-repeat top center;
  background-color: #BDEBE6;
  background-size: auto 100%;
  padding: 40px 0;
  margin-top: 45px;
}
.experiment-wrap .title-wrap {
  text-align: center;
  font-weight: bold;
}
.experiment-wrap .title-wrap .title {
  font-size: 38px;
  color: #222;
  letter-spacing: 5px;
  position: relative;
  z-index: 2;
}
.experiment-wrap .title-wrap .text-blue {
  color: #1e44cf;
}
.experiment-wrap .title-wrap .title-en {
  font-size: 34px;
  position: relative;
  background-image: -webkit-linear-gradient(top, #4f6d97, #fff, #fff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  top: -26px;
  letter-spacing: 2px;
  opacity: 0.8;
}
.experiment-wrap .more {
  text-align: right;
  width: 100%;
  display: block;
  margin-bottom: 15px;
}
.experiment-wrap .experiment-list {
  background: #fff;
  padding: 15px 30px;
}
.experiment-wrap .more i {
  display: inline-block;
  width: 48px;
  height: 18px;
  line-height: 18px;
  background: #f1f1f1;
  border-radius: 9px;
  text-align: center;
  color: #555555;
  font-size: 16px;
  font-weight: bold;
}
.experiment-list {
  margin-top: 20px;
  overflow: hidden;
}
.experiment-list li {
  float: left;
  width: 346px;
  min-height: 278px;
  margin-right: 50px;
  margin-bottom: 30px;
}
.experiment-list li:nth-child(3n) {
  margin-right: 0;
}
.experiment-list .img-wrap {
  width: 100%;
  height: 184px;
  position: relative;
}
.experiment-list .img-wrap img {
  width: 100%;
  height: 100%;
}
.experiment-list .biaoti-wrap {
  overflow: hidden;
  padding-top: 10px;
}
.experiment-list .biaoti-wrap .p1 {
  font-size: 15px;
  color: #333;
  font-weight: bold;
}
.experiment-list .biaoti-wrap .p2 {
  font-size: 14px;
  color: #888;
  margin-top: 5px;
}
.experiment-list .msg-wrap {
  color: #888;
  font-size: 13px;
  margin-top: 20px;
  overflow: hidden;
  line-height: 20px;
}
.experiment-list .msg-wrap .p1 {
  float: left;
}
.experiment-list .line {
  padding: 0 5px;
}
.experiment-list .msg-wrap .p2 {
  float: right;
}
.experiment-list .msg-wrap .p2 i {
  margin-right: 5px;
  font-size: 14px;
  color: #c5c5c5;
}
.no-info {
  width: 100%;
  min-height: 278px;
  line-height: 100px;
  text-align: center;
  font-size: 18px;
  color: #999;
}
</style>
